import { Navigate } from "react-router-dom";

// Função para verificar se o usuário está autenticado
const isAuthenticated = () => {
  const user = localStorage.getItem("userToken");
  return user && user !== "undefined" && user !== "null";
};

const LoggedRoute = ({ children }) => {
  if (isAuthenticated()) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default LoggedRoute;
